import React from 'react';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';
import { TableTopItemContainer } from './table-loader.styles';
import { TABLE_LOADER_OPTIONS , DEFAULT_COLUMNS_COUNT, DEFAULT_ROWS_COUNT } from '../../constants/table-loader-options';


export const TableLoader = ({
  testId = 'table-loader',
  hideSearchBar,
  hideFilters,
  hideActions,
  columnsCount = DEFAULT_COLUMNS_COUNT,
  shouldRightAlignLastCol,
  filtersCount = 2,
  columnsWidth,
  hideHeader,
  rowsCount = DEFAULT_ROWS_COUNT,
}: TABLE_LOADER_OPTIONS) => {
  const filterBottomMargin = '3rem';
  const filterHeight = '24px';

  const renderSearchAndFilters = () => {
    return (
      <>
        {hideSearchBar || (
          <TableTopItemContainer>
            <SkeletonLoader
              testId={`${testId}-search-bar`}
              height={filterHeight}
              width="25%"
              marginBottom={filterBottomMargin}
              marginRight="0.5rem"
            />
          </TableTopItemContainer>
        )}
        {hideFilters || (
          <TableTopItemContainer>
            {Array.from({ length: filtersCount }).map((_, index) => (
              <SkeletonLoader
                key={index}
                testId={`${testId}-filter-${index}`}
                height={filterHeight}
                width="10%"
                marginBottom={filterBottomMargin}
              />
            ))}
          </TableTopItemContainer>
        )}
      </>
    );
  };

  const renderActions = () => {
    return (
      hideActions || (
        <TableTopItemContainer>
          <SkeletonLoader height={filterHeight} width="15%" marginBottom={filterBottomMargin} isRightAligned />
        </TableTopItemContainer>
      )
    );
  };

  const renderTableCell = (index: number) => {
    const marginRight = 32;
    const isLastRow = index === columnsCount - 1;
    const isRightAligned = shouldRightAlignLastCol && isLastRow;

    return (
      <SkeletonLoader
        key={index}
        testId={`${testId}-cell-${index}`}
        width={columnsWidth ? columnsWidth : (100 - marginRight) / columnsCount + '%'}
        marginRight={marginRight + 'px'}
        isRightAligned={isRightAligned}
      />
    );
  };

  return (
    <div data-testid={testId}>
      <SkeletonLoaderWrapper>
        {renderSearchAndFilters()}
        {renderActions()}
      </SkeletonLoaderWrapper>
      {hideHeader || (
        <>
          <SkeletonLoaderWrapper>
            {/* Table head */}
            {Array.from({ length: columnsCount }).map((_, index) => renderTableCell(index))}
          </SkeletonLoaderWrapper>
          <SkeletonLoaderWrapper>
            {/* Table header bottom border */}
            <SkeletonLoader width="100%" height="1px" />
          </SkeletonLoaderWrapper>
        </>
      )}
      {Array.from({ length: rowsCount }).map((_, index) => (
        // Table rows
        <SkeletonLoaderWrapper key={index} testId="skeleton-loader-wrapper-table-loader-body">
          {Array.from({ length: columnsCount }).map((_, index) => renderTableCell(index))}
        </SkeletonLoaderWrapper>
      ))}
    </div>
  );
};
